module.exports = {};



//////////////////
// WEBPACK FOOTER
// /var/www/html/ic-automation/wp-content/themes/digitalcover/node_modules/core-js/internals/hidden-keys.js
// module id = 24
// module chunks = 0